import React from 'react';
import { useCurrentRoute, Link, useNavigation } from 'react-navi';
import { Hero, NewsSection } from '@contest-web/components/src/sections';
import { NewsItem } from '@contest-web/components/src/elements';
import { EntriesNavBar, EntryCard, LegendVoice } from '@contest-web/components/src/components';
import { AboutSection } from '../components/sections/About';

function IndexApp() {
  let route = useCurrentRoute();
  let navigation = useNavigation();
  return (
    <>
      <Hero
        logoImageSrc="/images/logo_white.svg"
        entryUrl={`${process.env.REACT_APP_ENTRY_FORM_URL}${route.url.search}`}
      >
        <h1 className="title is-stripe is-primary is-spaced is-size-4-mobile" style={{ marginBottom: '1rem' }}>
          <span className="is-letter-spacing-2px">
            日本一の新入生を決める
            <br className="is-hidden-tablet" />
            ミスコンテスト
          </span>
        </h1>
        <Link
          className="button is-size-6 is-hero is-inverted is-outlined is-primary is-medium has-text-weight-bold"
          href="#award"
        >
          <span className="icon is-small">
            <i className="fas fa-caret-square-down" />
          </span>
          <span>グランプリがついに決定!!</span>
        </Link>
      </Hero>

      {/* ↓ 結果発表　*/}

      <section id="award" className="section has-background-gold-stripe">
        <div className="container has-text-centered">
          <h1 className="title is-margin-bottom-4 ">
            <span className="is-family-secondary has-text-gold">AWARD</span>
            受賞者一覧
          </h1>
          {/* 受賞者一覧 */}
          {/* グランプリ x1 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-3 has-text-weight-bold is-margin-bottom-2">グランプリ</h1>
            <div className="columns is-centered is-mobile">
              <div className="column is-full" style={{ maxWidth: 400 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${425}`);
                  }}
                  lazy
                  entryNumber={425}
                  name={'中川紅葉'}
                  college={'青山学院大学'}
                  twitter={'frecam19_425'}
                  instagram={'kero908'}
                />
              </div>
            </div>
          </div>
          {/* 準グランプリ x 2 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-4 is-margin-bottom-2 has-text-weight-bold">準グランプリ</h1>
            <div className="columns is-mobile is-centered">
              <div className="column is-half" style={{ maxWidth: 320 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${6}`);
                  }}
                  lazy
                  entryNumber={6}
                  name={'望月優夢'}
                  college={'早稲田大学'}
                  twitter={'frecam19_006'}
                  instagram={'you_your_yumu'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 320 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${73}`);
                  }}
                  lazy
                  entryNumber={73}
                  name={'斉藤里奈'}
                  college={'中央大学'}
                  twitter={'frecam19_073'}
                  instagram={'riiii_naa____'}
                />
              </div>
            </div>
          </div>
          {/* 審査員特別賞 x 3 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-4 is-margin-bottom-2 has-text-weight-bold">審査員特別賞</h1>
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${211}`);
                  }}
                  lazy
                  entryNumber={211}
                  name={'渡辺萌菜'}
                  college={'中央大学'}
                  twitter={'frecam19_211'}
                  instagram={'moena._.w'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${374}`);
                  }}
                  lazy
                  entryNumber={374}
                  name={'村上由樹'}
                  college={'共立女子短期大学'}
                  twitter={'frecam19_374'}
                  instagram={'___22.5cm'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${397}`);
                  }}
                  lazy
                  entryNumber={397}
                  name={'坂本奈優'}
                  college={'慶應義塾大学'}
                  twitter={'frecam19_397'}
                  instagram={'nayunayu_0629'}
                />
              </div>
            </div>
          </div>
          {/*
            リゼウォーク賞 x 1
            リゼクリニック賞 x 1
          */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">リゼクリニック賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${265}`);
                  }}
                  lazy
                  entryNumber={265}
                  name={'宮平べれん'}
                  college={'立正大学'}
                  twitter={'frecam19_265'}
                  instagram={'xooxxooz'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">リゼウォーク賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${211}`);
                  }}
                  lazy
                  entryNumber={211}
                  name={'渡辺萌菜'}
                  college={'中央大学'}
                  twitter={'frecam19_211'}
                  instagram={'moena._.w'}
                />
              </div>
            </div>
          </div>
          {/*
            アスク賞 x 1
            モデルプレス賞 x 1
            DHC賞 x 1
           */}
          <div className="is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">テレビ朝日アスク賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${144}`);
                  }}
                  lazy
                  entryNumber={144}
                  name={'山田璃々子'}
                  college={'慶應義塾大学 環境情報学部'}
                  twitter={'frecam19_144'}
                  instagram={'ririkosworld'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">DHC賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${402}`);
                  }}
                  lazy
                  entryNumber={402}
                  name={'千葉こころ'}
                  college={'東京成徳大学'}
                  twitter={'frecam19_402'}
                  instagram={'chibako_o'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">モデルプレス賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${425}`);
                  }}
                  lazy
                  entryNumber={425}
                  name={'中川紅葉'}
                  college={'青山学院大学'}
                  twitter={'frecam19_425'}
                  instagram={'kero908'}
                />
              </div>
            </div>
          </div>
          {/*
            mysta賞 x 1
            SHOWROOM賞 x 1
          */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">mysta賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${254}`);
                  }}
                  lazy
                  entryNumber={254}
                  name={'前原未夢'}
                  college={'沖縄女子短期大学'}
                  twitter={'frecam19_254'}
                  instagram={'miyupink9.6'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">SHOWROOM賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${73}`);
                  }}
                  lazy
                  entryNumber={73}
                  name={'斉藤里奈'}
                  college={'中央大学'}
                  twitter={'frecam19_073'}
                  instagram={'riiii_naa____'}
                />
              </div>
            </div>
          </div>
          {/* ミスコレ賞 x 1 */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">ミスコレ賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${395}`);
                  }}
                  lazy
                  entryNumber={395}
                  name={'寺岡茉莉花'}
                  college={'関西学院大学'}
                  twitter={'frecam19_395'}
                  instagram={'_xjsmnx_'}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 受賞者一覧 */}
      <EntriesNavBar />

      {/* ↑ 結果発表 */}

      <AboutSection id="about" />
      <section id="history" className="section" style={{ backgroundColor: '#f7f8fa' }}>
        <div className="container">
          <div className="columns is-vcentered is-variable is-8 is-row-reverse">
            <div className="column is-6">
              <h1 className="title">
                <span className="is-family-secondary">HISTORY</span>
                昨年の様子
              </h1>
              <p className="is-size-5 is-size-6-mobile">
                昨年の「FRESH CAMPUS CONTEST 2018」は、
                <br />
                けやき坂46、SILENT SIRENらが出演した「AGESTOCK2018 in TOKYO DOME CITY HALL」にて開催されました。
                <br />
                <br />
                "日本一かわいい新入生"として、同志社大学の永松野々花さんがグランプリに輝きました。
              </p>
            </div>
            <div className="column is-narrow">
              <picture>
                <source srcSet="/images/last_year@2x.webp" type="image/webp" />
                <img src="/images/last_year@2x.png" width="864" height="480" style={{ width: 864 }} />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <h1 className="title has-text-centered">
            <span className="is-family-secondary">VOICE</span>
            歴代受賞者の声
          </h1>
          <div className="columns is-multiline is-margin-top-2">
            <div className="column is-12 is-margin-bottom-1">
              <LegendVoice
                style={{ backgroundColor: 'rgba(242, 97, 97, 0.1)' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2017年度 グランプリ
                  </p>
                }
                title={<>大学生活を充実させる出発点</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">名古屋外国語大学 大脇有紗さん</p>
                    <p>
                      私はFRESH CAMPUS CONTESTに参加して、自分に自信を持つことが出来ました。
                      <br />
                      大学に通っているだけではできない経験が沢山できました。
                      <br />
                      いろんな方との関わりを通じて視野も広がり、一生懸命ひとつの目標に向かって頑張り続ける大変さや達成感も知りました。
                      <br />
                      大変なこともありましたが、応援してくれた方々が支えてくださいました。
                      {/*<br />*/}
                      {/*大学生活を充実させる出発点にもなると思います。勇気を出して応募してみてください。*/}
                    </p>
                  </>
                }
                src="/images/oowaki@2x.jpg"
              />
            </div>
            <div className="column is-12 is-margin-bottom-1">
              <LegendVoice
                style={{ backgroundColor: 'rgba(242, 97, 97, 0.1)' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2017年度 準グランプリ
                  </p>
                }
                title={<>フレキャンは私の財産</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">日本大学 刈川くるみさん</p>
                    <p>
                      私はこのコンテストを経験して人として強くなることができました。
                      <br />
                      地方から一人で上京して不安しかなかったのですが、フレキャンで沢山の方に出会い、貴重な時間を過ごさせて頂けたのは私の財産です。
                      {/*<br />*/}
                      {/*何かに挑戦するのは勇気がいりますが、夢に向かって一緒に頑張りましょう^^*/}
                      {/*<br />*/}
                      {/*応援しています！*/}
                      {/*<br />*/}
                    </p>
                  </>
                }
                src="/images/karikawa@2x.jpg"
              />
            </div>
            <div className="column is-12 is-margin-bottom-1">
              <LegendVoice
                style={{ backgroundColor: 'rgba(242, 97, 97, 0.1)' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2016年度 グランプリ
                  </p>
                }
                title={<>自分の夢に近付けたらいいなと思い参加しました。</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">青山学院大学 遠野愛さん</p>

                    <p>
                      私は少しでも自分の夢に近付けたらいいなと思いこのFRESH CAMPUS CONTESTに参加しました。
                      <br />
                      もちろん大変なこともあったけど、たくさんの方に応援していただいて成長できた半年間でした。
                      {/*<br />*/}
                      {/*何かに向かってがむしゃらに努力することは、普通に大学生活を送っているだけではなかなか経験できません。*/}
                      {/*<br />*/}
                      {/*今、参加を迷っている一年生には自分の世界を広げるためにも是非FRESH CAMPUS*/}
                      {/*CONTESTに応募してほしいです。*/}
                    </p>
                  </>
                }
                src="/images/toono@2x.jpg"
              />
            </div>
            <div className="column is-12">
              <LegendVoice
                style={{ backgroundColor: 'rgba(242, 97, 97, 0.1)' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2015年度 準グランプリ
                  </p>
                }
                title={<>自分の可能性を広げたり、自分をより輝かせる機会をくれるコンテスト</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">青山学院大学 井口綾子さん</p>

                    <p>
                      私はこのコンテスト出場を通じて運営してくださっている方々はもちろん、候補者の皆さんなど沢山の素敵な方々と出会うことができ、そのおかげで新しい世界を見ることができるようになりました！
                      {/*<br />*/}
                      {/*自分の可能性を広げたり、自分をより輝かせる機会をくれる本当に素敵なコンテストなので、少しでも多くの方がチャレンジしてくださることを心から願っています！*/}
                    </p>
                  </>
                }
                src="/images/inokuchi@2x.jpg"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="section" style={{ backgroundColor: '#f7f8fa' }}>
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary">REQUIREMENT</span>
            応募資格
          </h1>
          <h2 className="subtitle has-text-primary has-text-italic has-text-centered has-text-weight-bold">
            全国どこからでもご参加頂けます！
          </h2>
          <div className="notification is-white">
            <div className="content">
              <ul className="is-margin-top-0">
                <li>応募受付対象者：四年制大学・短期大学・大学院・専門学校等、それらに相当する学校に在籍する方。</li>
                <li>2019年度入学の新一年生であること。</li>
              </ul>
            </div>
          </div>

          <div className="columns">
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  スマホ・インターネット利用で参加できる選考
                </h1>
                <p>
                  WEB投票、ツイッターの利用など、インターネット環境があれば、全国どこからでも選考にご参加いただくことが可能です。
                </p>
              </div>
            </div>
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  東京近郊以外在住のファイナリストには、表彰ステージ(東京で開催）への交通費支給あり
                </h1>
                <p>
                  表彰ステージは、例年11月ごろに東京で開催されます。ファイナリストに選ばれた遠方の方には規定に基づいて交通費が支給されます。
                </p>
              </div>
            </div>
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  過去には、関西/九州/四国からのファイナリストも！
                </h1>
                <p>北は北海道から南は沖縄まで、日本全国の大学生の方からのご応募をお待ちしています！</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary">SCHEDULE</span>
            スケジュール
          </h1>
          <div className="timeline is-centered">
            <header className="timeline-header">
              <span className="tag is-medium has-text-weight-bold">エントリー開始</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">~ 4月30日</p>
                <p className="has-text-weight-bold">
                  1次エントリー
                  <br className="is-hidden-tablet" />
                  締切
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">5月10日12:00 ~ 5月17日11:59</p>
                <p className="has-text-weight-bold">
                  Aブロック2次審査
                  <br className="is-hidden-tablet" />
                  (1次エントリー)
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">~ 5月26日</p>
                <p className="has-text-weight-bold">
                  2次エントリー
                  <br className="is-hidden-tablet" />
                  締切
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">5月30日12:00〜6月6日11:59</p>
                <p className="has-text-weight-bold">
                  Bブロック2次審査
                  <br className="is-hidden-tablet" />
                  (2次エントリー)
                </p>
              </div>
            </div>
            <div className="timeline-item ">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">~ 6月9日</p>
                <p className="has-text-weight-bold">
                  3次エントリー
                  <br className="is-hidden-tablet" />
                  締切
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">6月13日12:00〜6月20日11:59</p>
                <p className="has-text-weight-bold">
                  Cブロック2次審査
                  <br className="is-hidden-tablet" />
                  (3次エントリー)
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">3次審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月3日12:00〜8月12日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.showroom-live.com/event/frecam19_kc19aw"
                    target="_blank"
                  >
                    SHOWROOM審査
                  </a>
                </p>
                <p className="heading">8月3日12:00〜8月20日21:59</p>
                <p className="has-text-weight-bold">WEB審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月13日20:00〜8/20日21:59</p>
                <p className="has-text-weight-bold">mysta審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月23日</p>
                <p className="has-text-weight-bold">
                  3次審査通過者
                  <br className="is-hidden-tablet" />
                  発表
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">4次審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月4日12:00〜9月29日21:59</p>
                <p className="has-text-weight-bold">WEB審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月4日12:00〜9月6日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.showroom-live.com/event/ray19_frecam_yosen"
                    target="_blank"
                  >
                    SHOWROOM審査 予選
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月13日12:00〜9月15日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">SHOWROOM審査 準決勝</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月16日20:00〜9月29日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">mysta審査</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月20日12:00〜9月29日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">SHOWROOM審査 決勝</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月3日</p>
                <p className="has-text-weight-bold">
                  4次審査通過者
                  <br className="is-hidden-tablet" />
                  発表
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">セミファイナル審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月7日12:00〜10月20日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light" href="/semifinal">
                    WEB審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月11日20:00〜10月20日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.mysta.tv/blog/2019/10/02/fresh-campus-contest-201910/"
                  >
                    mysta審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月16日11:00～10月20日23:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline" href="/news/2019-10-15">
                    特別協賛審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月23日</p>
                <p className="has-text-weight-bold">
                  セミファイナル審査通過者
                  <br className="is-hidden-tablet" />
                  発表
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag is-primary has-text-weight-bold">ファイナル審査</span>
            </header>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">10月29日19:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-black-ter">WEB審査</a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">11月2日20:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-black-ter has-text-underline"
                    href="https://www.showroom-live.com/event/frecam19_final"
                  >
                    SHOWROOM審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">11月4日20:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-black-ter has-text-underline"
                    href="https://appweb.mysta.tv/web/share/challenge/?challenge_id=2212&creative=2019-1104-1658"
                  >
                    mysta審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">10月29日19:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-black-ter has-text-underline" href="/news/2019-10-29">
                    特別協賛審査
                  </a>
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <a
                href="/news/2019-10-04"
                className="tag button is-medium is-primary has-text-weight-bold is-flex-direction-column"
                style={{ height: 60 }}
              >
                <span className="is-size-7">2019年11月17日(日)</span>
                <span className="has-text-underline">表彰式</span>
              </a>
            </header>
          </div>
        </div>
      </section>
      <section className="section" style={{ backgroundColor: 'rgb(230, 238, 242)' }}>
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary has-text-link">姉妹コンテスト</span>
            <img src="/images/logo_misscircle.svg" width="300" />
          </h1>
          <div className="columns is-centered">
            <div className="column is-narrow">
              <div className="card is-rounded" style={{ maxWidth: 520, margin: '0 auto' }}>
                <div className="card-image">
                  <figure className="image">
                    <img src="/images/banner@2x.jpg" width="520" height="273" />
                  </figure>
                </div>
                <div className="card-content">
                  <div className="media">
                    <div className="media-content">
                      <p className="title is-4 has-text-link">日本一のサークル美人を決めるコンテスト</p>
                      <p className="subtitle is-6 has-text-link">大学のサークルに所属する美女大募集！</p>
                    </div>
                  </div>

                  <div className="content">
                    学生中心で形成されたサークル、部活、同好会、ゼミ、研究会、及びそのいずれかに準ずるコミュニティに所属していれば応募可能！
                  </div>
                </div>
                <footer className="card-footer">
                  <div className="card-footer-item">
                    <a
                      className="button is-medium is-fullwidth is-link has-text-weight-bold"
                      href="https://2019.misscircle.jp/?utm_source=frecam&utm_medium=banner"
                      target="_blank"
                      rel="noopener"
                    >
                      <span>特設サイトを見る</span>
                    </a>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NewsSection id="news">
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="#award">
              グランプリが決定しました。
            </a>
          }
          time="2019-11-17"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-11-11-faq">
              表彰式について、注意事項・よくある質問を掲載しました。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-11-11">
              スペシャルプレゼンターとして昨年度グランプリ「永松野々花」さんの出演が決定致しました。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-29">
              「ファイナル 特別協賛審査」リゼクリニック・メンズリゼ様とのコラボ企画「リゼウォーク賞」結果発表。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          title={
            <a
              className="has-text-primary has-text-underline"
              href="https://www.rizeclinic.com/missmrcampus2019/frecam-vote"
              target="_blank"
            >
              ファイナル WEB投票サイトがオープンしました
            </a>
          }
          time="2019-10-29"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-29">
              ファイナル 特別協賛審査の詳細が決定しました。
            </a>
          }
          time="2019-10-29"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-15">
              「特別協賛審査」リゼクリニック・メンズリゼ様とのコラボ企画第1弾「＃リゼクリニックの日」結果発表。
            </a>
          }
          time="2019-10-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/final">
              セミファイナル審査通過者を発表しました。
            </a>
          }
          time="2019-10-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-15">
              セミファイナル期間「特別協賛審査」として特別協賛の医療脱毛専門の「リゼクリニック・メンズリゼ」様とのコラボ企画が決定しました。
            </a>
          }
          time="2019-10-15"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/semifinal">
              セミファイナル審査がスタートしました。
            </a>
          }
          time="2019-10-07"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-04">
              「FRESH CAMPUS CONTEST 2019 supported by リゼクリニック ・メンズリゼ」表彰式の開催が決定しました。
            </a>
          }
          time="2019-10-04"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/semifinal">
              4次審査通過者を発表しました。
            </a>
          }
          time="2019-10-03"
        />
        <NewsItem title="リゼクリニック様が特別協賛社に決定しました" time="2019-10-03" />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-09-08-kobecollection">
              9/8(日) 神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-「SHOWROOM
              SPECIALSTAGE」にて、モデルとしてフレキャン候補者が登場しました。
            </a>
          }
          time="2019-09-08"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/third">
              4次審査がスタートしました。
            </a>
          }
          time="2019-09-04"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/third">
              3次審査通過者を発表しました。
            </a>
          }
          time="2019-08-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second">
              3次審査が終了しました。
            </a>
          }
          time="2019-08-20"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-08-07-tvasahi">
              8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭りに候補者が参加しました
            </a>
          }
          time="2019-08-07"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second">
              3次審査がスタートしました。
            </a>
          }
          time="2019-08-03"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://www.kobe-collection.com/" target="_blank">
              KOBE COLLECTION「SHOWROOM SPECIALSTAGE」とのタイアップが決定しました！
            </a>
          }
          time="2019-07-16"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second/C">
              Cブロック二次審査通過者を発表しました。
            </a>
          }
          time="2019-06-25"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/first/c">
              Cブロック二次審査 WEB投票がスタートしました。
            </a>
          }
          time="2019-06-13"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second/b">
              Bブロック二次審査通過者を発表しました。
            </a>
          }
          time="2019-06-11"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://mdpr.jp/news/1841275" target="_blank">
              5/30 Bブロック出場者をモデルプレスにて発表しました。
            </a>
          }
          time="2019-05-30"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/first/b">
              Bブロック二次審査 WEB投票がスタートしました。
            </a>
          }
          time="2019-05-30"
        />
        <NewsItem title="2次エントリーがスタートしました。" time="2019-05-30" />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second/a">
              Aブロック二次審査通過者を発表しました。
            </a>
          }
          time="2019-05-23"
        />
        <NewsItem title="Aブロック二次審査 WEB投票が終了しました。" time="2019-05-17" />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://mdpr.jp/news/1837843" target="_blank">
              5/10 Aブロック出場者をモデルプレスにて発表しました。
            </a>
          }
          time="2019-05-10"
        />
        <NewsItem title="Aブロック二次審査 WEB投票がスタートしました。" time="2019-05-10" />
        <NewsItem title="2次エントリーがスタートしました。" time="2019-05-01" />
        <NewsItem
          title={
            <a
              className="has-text-primary has-text-underline"
              href="https://mdpr.jp/news/detail/1834402"
              target="_blank"
            >
              モデルプレスにてコンテスト情報が掲載されました。
            </a>
          }
          time="2019-04-19"
        />
        <NewsItem title="「モデルプレス」が特別協力に決定しました。" time="2019-04-18" />
        <NewsItem title="FRESH CAMPUS CONTEST 2019 公式サイトを公開致しました。" time="2019-03-26" />
      </NewsSection>
    </>
  );
}

export default IndexApp;
